import { c as _c } from "react/compiler-runtime";
import { FeedbackComposer } from "@/entities/feature-announcement-feedback";
import type { PendingReplyAttachment } from "@/entities/feature-announcement-feedback";

/**
 * User-facing reply composer — a thin wrapper over the shared `FeedbackComposer`
 * with the user-side defaults (icon-only send, no character counter, no keyboard
 * hint) so the customer-facing surface is unchanged by the extraction. Enter
 * sends, Shift+Enter inserts a newline; the 5000-char cap is enforced inside the
 * shared composer (the server remains the source of truth via InvalidReplyContent).
 */
export function FeedbackReplyBox(t0) {
  const $ = _c(11);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      showExpectation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const showExpectation = t1 === undefined ? true : t1;
  let t2;
  if ($[3] !== props || $[4] !== showExpectation) {
    t2 = showExpectation && !props.disabled && <p className="text-[11px] leading-snug text-gray-400">The Cova team reads every message. Replies can take a little time, so thanks for bearing with us.</p>;
    $[3] = props;
    $[4] = showExpectation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props) {
    t3 = <FeedbackComposer {...props} sendVariant="icon-only" />;
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="space-y-2">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}